import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const OverlayWrapper = styled.div<IThemeProps>`
  position: relative;
  width: 100%;
  max-width: 540px;
  background: #fff;
  z-index: ${(props) => props.theme.zIndex.h300};
  border: 3px solid ${(props) => props.theme.colors.primary};
  padding: ${(props) => props.theme.spacing.desktop.s500}px;

  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 95vw;
    padding: ${(props) => props.theme.spacing.desktop.s200}px;
  }
`;

export const OverlayContent = styled.div<
  IThemeProps<{ $hasTopPadding: boolean }>
>`
  width: 100%;
  padding-top: ${(props) =>
    props.$hasTopPadding ? props.theme.spacing.desktop.s800 : 0}px;
`;

export const OverlayClose = styled.div<IThemeProps>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  padding: ${(props) => props.theme.spacing.desktop.s100}px;
  margin: ${(props) => props.theme.spacing.desktop.s200}px;
  color: ${(props) => props.theme.colors.black};
  background: transparent;
  cursor: pointer;
  z-index: ${(props) => props.theme.zIndex.h500};

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 0;
    svg {
      padding: 3px;
    }
  }
`;

export const OutroFeedback = styled.div<IThemeProps>`
  position: relative;
  text-align: center;

  h3 {
    margin: ${(props) => props.theme.spacing.desktop.s500}px 0;
    font-size: ${(props) => props.theme.typography.h700};
  }
`;

export const OutroFeedbackIcon = styled.div<IThemeProps<{ $success: boolean }>>`
  display: inline-flex;
  padding: ${(props) => props.theme.spacing.desktop.s200}px;
  background: ${(props) =>
    props.$success ? props.theme.colors.success : props.theme.colors.error};
`;

export const LightContainer = styled.div`
  background: #fff;
  max-width: 600px;
  padding: 24px;
  border-radius: 4px;
  box-sizing: border-box;
`;

export const LightIconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  cursor: pointer;
`;
